import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./RegisterList.css";
import { useTranslation } from "react-i18next";
import {
  getUsers,
  deleteUser,
  getUsersByRole,
  getRelatedUsers,
  getUserById,
  getOrganizationsByCoordinatorId,
} from "../../../services/UsersService";
import _ from "lodash";
import { FaEdit, FaTrash, FaShoppingCart, FaUser, FaEye, FaArrowLeft } from "react-icons/fa";
import Modal from "../../../components/modal/Modal";
import Pagination from "../../../components/pagination/Pagination";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../../components/loading/Loading";
import { useAuth } from "../../../hooks/useAuth";
import SalesWizard from "../sale/SalesWizard";
import { useDispatch } from "react-redux";
import { selectClient } from "../../../features/userSlice/userSlice";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { roles, rolesIds } from "../../../constants/roles";
import { PrimaryButton } from "../../../components/primary/PrimaryButton";
import { BiSolidDownArrow, BiSolidUpArrow } from "react-icons/bi";
import { Selector } from "../../../components/selector/Selector";
import { capitalized } from "../../../utils";
import UserDetails from "../register/components/UserDetails";
import RegisterDelete from "../register/components/registerDelete/RegisterDelete";
import TableUsers from "../register/TableUsers";
import Register from "../register/Register";
import InfoClient from "./InfoClient.jsx";
import LongArrow from "../../../assets/icons/LongArrow.jsx";

export const initializeRoles = [
  { value: "all", label: "Todos" },
  { value: roles.ADMIN, label: capitalized(roles.ADMIN) },
  { value: roles.CLIENT, label: capitalized(roles.CLIENT) },
  { value: roles.COORDINATOR, label: capitalized(roles.COORDINATOR) },
  { value: roles.ORGANIZATION, label: capitalized(roles.ORGANIZATION) },
  { value: roles.SELLER, label: capitalized(roles.SELLER) },
];

const removeRoles = (role) => {
  if (role === roles.CLIENT) {
    return [];
  }

  if (role === roles.ADMIN) {
    return initializeRoles.filter((r) => r.value !== roles.ADMIN);
  }

  if (role === roles.COORDINATOR) {
    return initializeRoles.filter(
      (r) => ![roles.ADMIN, roles.COORDINATOR].includes(r.value)
    );
  }

  if (role === roles.ORGANIZATION) {
    return initializeRoles.filter(
      (r) =>
        ![roles.ADMIN, roles.ORGANIZATION, roles.COORDINATOR].includes(r.value)
    );
  }

  if (role === roles.SELLER) {
    return initializeRoles.filter(
      (r) =>
        ![
          roles.ADMIN,
          roles.ORGANIZATION,
          roles.COORDINATOR,
          roles.SELLER,
        ].includes(r.value)
    );
  }

  return initializeRoles;
};

const heightRegistrationForm = (type, role) => {
  if (type === "cliente") {
    return "690px";
  }
  if (type === "organizacion") {
    return "730px";
  }
  if (type === "vendedor") {
    return "615px";
  }
  return role === roles.SELLER ? "690px" : "615px";
};

const data = [
  {
    id: 1,
    name: "Lexi Daugherty Sarina Rath Jr.",
    type: "organization",
    sellers: [
      {
        id: 101,
        name: "Conner Zieme Dr. Olaf Heidenreich",
        type: "seller",
        clients: [
          {
            id: 63,
            name: "Jodie",
            last_name: "Ortiz",
            country_code: "+52",
            phone: "3118428831",
            email: "andrescliente@email.com",
            email_verified_at: null,
            profile_completed: 1,
            created_at: "2025-02-11T03:37:51.000000Z",
            updated_at: "2025-02-11T03:39:24.000000Z",
            stripe_id: "cus_RkfdrYN0KV0AXS",
            pm_type: null,
            pm_last_four: null,
            trial_ends_at: null,
            deleted_at: null,
            roles: [
              {
                id: 6,
                name: "Cliente",
                guard_name: "web",
                created_at: "2024-01-31T21:45:22.000000Z",
                updated_at: "2024-01-31T21:45:22.000000Z",
                pivot: {
                  model_type: "App\\Models\\User",
                  model_id: 63,
                  role_id: 6,
                },
              },
            ],
            client: {
              id: 26,
              user_id: 63,
              default_payment_method: null,
              seller_id: 12,
              zip_code: "75352",
              full_address: "calle 13 # 10 - 32",
              created_at: "2025-02-11T03:37:51.000000Z",
              updated_at: "2025-02-11T03:37:51.000000Z",
              deleted_at: null,
              organization_code: "12",
              lands: [
                {
                  id: 552,
                  identifying_label: "Mz36 Lt6",
                  price: 120,
                  manzana: "36",
                  lote: "6",
                  surface: "500.00M2",
                  advance: 10000,
                  client_id: 26,
                  status: "separated",
                  separated_at: "2025-02-10 21:39:13",
                  paid_advance_at: null,
                  sold_at: null,
                  description:
                    "AL NORESTE 25.34 MTS. CON LOTE 8; AL NOROESTE 6.74 MTS. CON LOTE 7, 13.00 MTS. CON LOTE 5; AL SURESTE 19.73 MTS. CON CALLE AMAPOLAS; AL SUROESTE 25.34 MTS. CON LOTE 4",
                  location: "",
                  measurements: "",
                  section_id: 1,
                  catalog_path: "/storage/",
                  sketch_path: "/storage/",
                  boundaries_northwest:
                    "6.74 MTS. CON LOTE 7, 13.00 MTS. CON LOTE 5",
                  boundaries_northeast: "25.34 MTS. CON LOTE 8",
                  boundaries_southeast: "19.73 MTS. CON CALLE AMAPOLAS",
                  boundaries_southwest: "25.34 MTS. CON LOTE 4",
                  created_at: null,
                  updated_at: "2025-02-11T03:39:13.000000Z",
                  deleted_at: null,
                  product_id: null,
                  group_id: null,
                },
              ],
            },
            show: false,
          },
          {
            id: 62,
            name: "Carlota",
            last_name: "Paramo",
            country_code: "+52",
            phone: "3118428830",
            email: "andrescliente8@email.com",
            email_verified_at: null,
            profile_completed: 1,
            created_at: "2025-02-11T03:03:33.000000Z",
            updated_at: "2025-02-11T03:04:09.000000Z",
            stripe_id: "cus_Rkf5rE5S8iX4KD",
            pm_type: null,
            pm_last_four: null,
            trial_ends_at: null,
            deleted_at: null,
            roles: [
              {
                id: 6,
                name: "Cliente",
                guard_name: "web",
                created_at: "2024-01-31T21:45:22.000000Z",
                updated_at: "2024-01-31T21:45:22.000000Z",
                pivot: {
                  model_type: "App\\Models\\User",
                  model_id: 62,
                  role_id: 6,
                },
              },
            ],
            client: {
              id: 25,
              user_id: 62,
              default_payment_method: null,
              seller_id: 12,
              zip_code: "75352",
              full_address: "calle 13 # 10 - 32",
              created_at: "2025-02-11T03:03:33.000000Z",
              updated_at: "2025-02-11T03:03:33.000000Z",
              deleted_at: null,
              organization_code: "12",
              lands: [
                {
                  id: 556,
                  identifying_label: "Mz36 Lt10",
                  price: 120,
                  manzana: "36",
                  lote: "10",
                  surface: "500.00M2",
                  advance: 10000,
                  client_id: 25,
                  status: "separated",
                  separated_at: "2025-02-10 21:04:31",
                  paid_advance_at: null,
                  sold_at: null,
                  description:
                    "AL NORESTE 25.34 MTS. CON LOTE 12; AL NOROESTE 5.15 MTS. CON LOTE 11, 14.58 MTS. CON LOTE 9; AL SURESTE 19.73 MTS. CON CALLE AMAPOLAS; AL SUROESTE 25.34 MTS. CON LOTE 8",
                  location: "",
                  measurements: "",
                  section_id: 1,
                  catalog_path: "/storage/",
                  sketch_path: "/storage/",
                  boundaries_northwest:
                    "5.15 MTS. CON LOTE 11, 14.58 MTS. CON LOTE 9",
                  boundaries_northeast: "25.34 MTS. CON LOTE 12",
                  boundaries_southeast: "19.73 MTS. CON CALLE AMAPOLAS",
                  boundaries_southwest: "25.34 MTS. CON LOTE 8",
                  created_at: null,
                  updated_at: "2025-02-11T03:04:31.000000Z",
                  deleted_at: null,
                  product_id: null,
                  group_id: null,
                },
              ],
            },
            show: false,
          },
          {
            id: 61,
            name: "Dolly",
            last_name: "Monroy",
            country_code: "+52",
            phone: "3118428839",
            email: "andrescliente7@email.com",
            email_verified_at: null,
            profile_completed: 1,
            created_at: "2025-02-11T01:26:47.000000Z",
            updated_at: "2025-02-11T01:27:43.000000Z",
            stripe_id: "cus_RkdWmuFhy7NiBF",
            pm_type: null,
            pm_last_four: null,
            trial_ends_at: null,
            deleted_at: null,
            roles: [
              {
                id: 6,
                name: "Cliente",
                guard_name: "web",
                created_at: "2024-01-31T21:45:22.000000Z",
                updated_at: "2024-01-31T21:45:22.000000Z",
                pivot: {
                  model_type: "App\\Models\\User",
                  model_id: 61,
                  role_id: 6,
                },
              },
            ],
            client: {
              id: 24,
              user_id: 61,
              default_payment_method: null,
              seller_id: 12,
              zip_code: "75352",
              full_address: "calle 13 # 10 - 32",
              created_at: "2025-02-11T01:26:47.000000Z",
              updated_at: "2025-02-11T01:26:47.000000Z",
              deleted_at: null,
              organization_code: "12",
              lands: [
                {
                  id: 548,
                  identifying_label: "Mz36 Lt2",
                  price: 120,
                  manzana: "36",
                  lote: "2",
                  surface: "500.00M2",
                  advance: 10000,
                  client_id: 24,
                  status: "separated",
                  separated_at: "2025-02-10 19:28:43",
                  paid_advance_at: null,
                  sold_at: null,
                  description:
                    "AL NORESTE 25.34 MTS. CON LOTE 4; AL NOROESTE 19.73 MTS. CON LOTE 3; AL SURESTE 19.73 MTS. CON CALLE AMAPOLAS; AL SUROESTE 25.34 MTS. CON LOTE 1",
                  location: "",
                  measurements: "",
                  section_id: 1,
                  catalog_path: "/storage/",
                  sketch_path: "/storage/",
                  boundaries_northwest: "19.73 MTS. CON LOTE 3",
                  boundaries_northeast: "25.34 MTS. CON LOTE 4",
                  boundaries_southeast: "19.73 MTS. CON CALLE AMAPOLAS",
                  boundaries_southwest: "25.34 MTS. CON LOTE 1",
                  created_at: null,
                  updated_at: "2025-02-11T01:28:43.000000Z",
                  deleted_at: null,
                  product_id: null,
                  group_id: null,
                },
              ],
            },
            show: false,
          },
        ],
      },
      {
        id: 102,
        name: "Fabian Lopera",
        type: "seller",
        clients: [
          {
            id: 65,
            name: "Karol",
            last_name: "Quijano",
            country_code: "+52",
            phone: "3118428841",
            email: "andrescliente11@email.com",
            email_verified_at: null,
            profile_completed: 1,
            created_at: "2025-02-11T04:20:20.000000Z",
            updated_at: "2025-02-11T04:31:29.000000Z",
            stripe_id: "cus_RkgKVWF8sAC9cH",
            pm_type: null,
            pm_last_four: null,
            trial_ends_at: null,
            deleted_at: null,
            roles: [
              {
                id: 6,
                name: "Cliente",
                guard_name: "web",
                created_at: "2024-01-31T21:45:22.000000Z",
                updated_at: "2024-01-31T21:45:22.000000Z",
                pivot: {
                  model_type: "App\\Models\\User",
                  model_id: 65,
                  role_id: 6,
                },
              },
            ],
            client: {
              id: 28,
              user_id: 65,
              default_payment_method: null,
              seller_id: 12,
              zip_code: "75352",
              full_address: "calle 13 # 10 - 32",
              created_at: "2025-02-11T04:20:20.000000Z",
              updated_at: "2025-02-11T04:20:20.000000Z",
              deleted_at: null,
              organization_code: "12",
              lands: [
                {
                  id: 558,
                  identifying_label: "Mz36 Lt12",
                  price: 120,
                  manzana: "36",
                  lote: "12",
                  surface: "500.00M2",
                  advance: 10000,
                  client_id: 28,
                  status: "separated",
                  separated_at: "2025-02-10 22:29:55",
                  paid_advance_at: null,
                  sold_at: null,
                  description:
                    "AL NORESTE 25.34 MTS. CON LOTE 14; AL NOROESTE 4.36 MTS. CON LOTE 13, 15.38 MTS. CON LOTE 11; AL SURESTE 19.73 MTS. CON CALLE AMAPOLAS; AL SUROESTE 25.34 MTS. CON LOTE 10",
                  location: "",
                  measurements: "",
                  section_id: 1,
                  catalog_path: "/storage/",
                  sketch_path: "/storage/",
                  boundaries_northwest:
                    "4.36 MTS. CON LOTE 13, 15.38 MTS. CON LOTE 11",
                  boundaries_northeast: "25.34 MTS. CON LOTE 14",
                  boundaries_southeast: "19.73 MTS. CON CALLE AMAPOLAS",
                  boundaries_southwest: "25.34 MTS. CON LOTE 10",
                  created_at: null,
                  updated_at: "2025-02-11T04:29:55.000000Z",
                  deleted_at: null,
                  product_id: null,
                  group_id: null,
                },
              ],
            },
            show: false,
          },
          {
            id: 64,
            name: "Santiago",
            last_name: "Pulido",
            country_code: "+52",
            phone: "3118428840",
            email: "andrescliente10@email.com",
            email_verified_at: null,
            profile_completed: 1,
            created_at: "2025-02-11T04:15:41.000000Z",
            updated_at: "2025-02-11T04:16:30.000000Z",
            stripe_id: "cus_RkgFijMLlm3K1H",
            pm_type: null,
            pm_last_four: null,
            trial_ends_at: null,
            deleted_at: null,
            roles: [
              {
                id: 6,
                name: "Cliente",
                guard_name: "web",
                created_at: "2024-01-31T21:45:22.000000Z",
                updated_at: "2024-01-31T21:45:22.000000Z",
                pivot: {
                  model_type: "App\\Models\\User",
                  model_id: 64,
                  role_id: 6,
                },
              },
            ],
            client: {
              id: 27,
              user_id: 64,
              default_payment_method: null,
              seller_id: 12,
              zip_code: "75352",
              full_address: "calle 13 # 10 - 32",
              created_at: "2025-02-11T04:15:41.000000Z",
              updated_at: "2025-02-11T04:15:41.000000Z",
              deleted_at: null,
              organization_code: "12",
              lands: [],
            },
            show: false,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Fronteras",
    type: "organization",
    sellers: [
      {
        id: 103,
        name: "Vanessa Ortiz",
        type: "seller",
        clients: [
          {
            id: 60,
            name: "Wendy",
            last_name: "Rojas",
            country_code: "+52",
            phone: "3118428838",
            email: "andrescliente6@email.com",
            email_verified_at: null,
            profile_completed: 1,
            created_at: "2025-02-10T23:44:34.000000Z",
            updated_at: "2025-02-10T23:45:43.000000Z",
            stripe_id: "cus_RkbsSXSUlmM4kR",
            pm_type: null,
            pm_last_four: null,
            trial_ends_at: null,
            deleted_at: null,
            roles: [
              {
                id: 6,
                name: "Cliente",
                guard_name: "web",
                created_at: "2024-01-31T21:45:22.000000Z",
                updated_at: "2024-01-31T21:45:22.000000Z",
                pivot: {
                  model_type: "App\\Models\\User",
                  model_id: 60,
                  role_id: 6,
                },
              },
            ],
            client: {
              id: 23,
              user_id: 60,
              default_payment_method: null,
              seller_id: 12,
              zip_code: "75352",
              full_address: "calle 13 # 10 - 32",
              created_at: "2025-02-10T23:44:34.000000Z",
              updated_at: "2025-02-10T23:44:34.000000Z",
              deleted_at: null,
              organization_code: "12",
              lands: [
                {
                  id: 555,
                  identifying_label: "Mz36 Lt9",
                  price: 120,
                  manzana: "36",
                  lote: "9",
                  surface: "506.25M2",
                  advance: 10000,
                  client_id: 23,
                  status: "separated",
                  separated_at: "2025-02-10 17:46:12",
                  paid_advance_at: null,
                  sold_at: null,
                  description:
                    "AL NORESTE 24.66 MTS. CON LOTE 11; AL NOROESTE 20.53 MTS. CON CALLE ASTRANCIA; AL SURESTE 5.94 MTS. CON LOTE 8, 14.58 MTS. CON LOTE 10; AL SUROESTE 24.66 MTS. CON LOTE 7",
                  location: "",
                  measurements: "",
                  section_id: 1,
                  catalog_path: "/storage/",
                  sketch_path: "/storage/",
                  boundaries_northwest: "20.53 MTS. CON CALLE ASTRANCIA",
                  boundaries_northeast: "24.66 MTS. CON LOTE 11",
                  boundaries_southeast:
                    "5.94 MTS. CON LOTE 8, 14.58 MTS. CON LOTE 10",
                  boundaries_southwest: "24.66 MTS. CON LOTE 7",
                  created_at: null,
                  updated_at: "2025-02-10T23:46:12.000000Z",
                  deleted_at: null,
                  product_id: null,
                  group_id: null,
                },
              ],
            },
            show: false,
          },
          {
            id: 59,
            name: "Andres",
            last_name: "Ladino",
            country_code: "+52",
            phone: "3118428837",
            email: "andrescliente5@email.com",
            email_verified_at: null,
            profile_completed: 1,
            created_at: "2025-02-10T23:19:55.000000Z",
            updated_at: "2025-02-10T23:21:44.000000Z",
            stripe_id: "cus_RkbTJmvulBaRaJ",
            pm_type: null,
            pm_last_four: null,
            trial_ends_at: null,
            deleted_at: null,
            roles: [
              {
                id: 6,
                name: "Cliente",
                guard_name: "web",
                created_at: "2024-01-31T21:45:22.000000Z",
                updated_at: "2024-01-31T21:45:22.000000Z",
                pivot: {
                  model_type: "App\\Models\\User",
                  model_id: 59,
                  role_id: 6,
                },
              },
            ],
            client: {
              id: 22,
              user_id: 59,
              default_payment_method: null,
              seller_id: 12,
              zip_code: "75352",
              full_address: "calle 13 # 10 - 32",
              created_at: "2025-02-10T23:19:55.000000Z",
              updated_at: "2025-02-10T23:19:55.000000Z",
              deleted_at: null,
              organization_code: "12",
              lands: [
                {
                  id: 553,
                  identifying_label: "Mz36 Lt7",
                  price: 120,
                  manzana: "36",
                  lote: "7",
                  surface: "506.25M2",
                  advance: 10000,
                  client_id: 22,
                  status: "separated",
                  separated_at: "2025-02-10 17:22:28",
                  paid_advance_at: null,
                  sold_at: null,
                  description:
                    "AL NORESTE 24.66 MTS. CON LOTE 9; AL NOROESTE 20.53 MTS. CON CALLE ASTRANCIA; AL SURESTE 6.74 MTS. CON LOTE 6, 13.79 MTS. CON LOTE 8; AL SUROESTE 24.66 MTS. CON LOTE 5",
                  location: "",
                  measurements: "",
                  section_id: 1,
                  catalog_path: "/storage/",
                  sketch_path: "/storage/",
                  boundaries_northwest: "20.53 MTS. CON CALLE ASTRANCIA",
                  boundaries_northeast: "24.66 MTS. CON LOTE 9",
                  boundaries_southeast:
                    "6.74 MTS. CON LOTE 6, 13.79 MTS. CON LOTE 8",
                  boundaries_southwest: "24.66 MTS. CON LOTE 5",
                  created_at: null,
                  updated_at: "2025-02-10T23:22:28.000000Z",
                  deleted_at: null,
                  product_id: null,
                  group_id: null,
                },
              ],
            },
            show: false,
          },
        ],
      },
    ],
  },
];

function createArrayWithData({ size, position, data }) {
  if (position >= size || position < 0) {
    throw new Error("La posición debe estar dentro del rango del array.");
  }

  return Array.from({ length: size }, (_, index) => ({
    data: index === position ? data : null,
  }));
}

export default function AdministrativeHierarchy() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useAuth().user;
  const [users, setUsers] = useState([]);
  const [meta, setMeta] = useState(null);
  const [first, setFirst] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showTableUser, setShowTableUsers] = useState(false);
  const [tableUsers, setTableUsers] = useState([]);
  const [nameUser, setNameUser] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [showSale, setShowSale] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null);
  const [userToShow, setUserToShow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toggleDetails, setToggleDetails] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [searchByRol, setSearchByRol] = useState("all");
  const [type, setType] = useState("");

  const [admin, setAdmin] = useState(null);
  const [selectedUserRole, setSelectedUserRole] = useState("");
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [showInfoClient, setShowInfoClient] = useState(false);
  const [client, setClient] = useState(null);
  const [dataHierarchy, setDataHierarchy] = useState(null);
  const [sellers, setSellers] = useState([]);
  const [clients, setClients] = useState([]);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { id: clientId } = useParams();

  const debug = searchParams.get("debug") === "true";

  const role = useMemo(() => user?.roles?.[0]?.name?.toLowerCase(), [user]);

  /**
   * Handle show form to send values to register component
   */
  const handleShowForm = useCallback((theUser) => {
    if (!theUser?.id) {
      return;
    }

    const data = {
      id: theUser.id ? theUser.id : undefined,
      name: theUser.name,
      lastName: theUser.last_name,
      countryCode: theUser.country_code,
      phone: theUser.phone,
      email: theUser.email,
      zipCode: theUser.client ? theUser.client.zip_code : undefined,
      address: theUser.client ? theUser.client.full_address : undefined,
    };
    setUserToEdit(data);
    setShowForm(true);
  }, []);

  /**
   * Show alert confirm to delete
   */
  const handleDelete = useCallback((theUser) => {
    setUserToDelete(theUser);
    setShowDelete(true);
  }, []);

  const downloadFile = useCallback((theResponse) => {
    const url = window.URL.createObjectURL(new Blob([theResponse]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `users.xlsx`);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
  }, []);

  /**
   * Get user list in the page selected
   */
  const getUserList = useCallback(
    async (page, download = undefined) => {
      setLoading(true);
      const theUsers = await getUsers(page, download);
      setLoading(false);
      if (!download) {
        if (theUsers?.data?.data) {
          theUsers?.data?.data.forEach((theUser) => {
            theUser.show = false;
          });
          setUsers(theUsers?.data?.data);
          setMeta(theUsers?.data?.meta);
        }
      } else {
        downloadFile(theUsers?.data);
      }
    },
    [downloadFile]
  );

  /**
   * Get user list in the page selected
   */
  const getUserListByRole = useCallback(
    async (page, role, download = undefined) => {
      setLoading(true);
      const theUsers = await getUsersByRole(page, role, download);
      setLoading(false);
      if (!download) {
        if (theUsers?.data?.data) {
          theUsers.data?.data?.forEach((theUser) => {
            theUser.show = false;
          });
          setUsers(theUsers?.data?.data);
          setMeta(theUsers?.data?.meta);
        }
      } else {
        downloadFile(theUsers?.data);
      }
    },
    [downloadFile]
  );

  const handleShowTableUsers = useCallback(
    async (name, rol, id) => {
      setLoading(true);
      const { data } = await getRelatedUsers(id, rol);
      setLoading(false);
      setNameUser(name);
      setTableUsers(data);
      setShowTableUsers(!showTableUser);
    },
    [showTableUser]
  );

  /**
   * Handle page selected on pagination
   */
  const onPageSelected = useCallback(
    (pageSelected) => {
      if (meta && meta.current_page !== pageSelected) {
        getUserList(pageSelected);
      }
    },
    [getUserList, meta]
  );

  /**
   * Handle close modal and reload users list
   */
  const handleCloseModal = useCallback(() => {
    getUserList(1);
    setShowForm(false);
    setShowInfoClient(false);
    setShowTableUsers(false);
    setUserToEdit(null);
  }, [getUserList]);

  const handleShowUserDetails = useCallback((theUser) => {
    setUserToShow(theUser);
    setToggleDetails(true);
  }, []);

  /**
   * Handle cancel delete section
   */
  const handleCancelDelete = useCallback(() => {
    setUserToDelete(null);
    setShowDelete(false);
  }, []);

  /**
   * Handle confirm delete
   */
  const handleConfirmDelete = useCallback(async () => {
    try {
      setLoading(true);
      const response = await deleteUser(userToDelete.id);
      setLoading(false);
      if (response.status === 200) {
        toast.success(t("registerPage.delete"));
        setShowDelete(false);
        setUserToDelete(null);
        getUserList(1);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }, [getUserList, t, userToDelete]);

  /**
   * Handle add user to show form
   */
  const handleAdd = useCallback(() => {
    setShowForm(true);
  }, []);

  const handleInfoClient = useCallback((client) => {
    setShowInfoClient(true);
    setClient(client);
  }, []);

  /**
   * Handle success in form
   */
  const handleSuccess = useCallback(() => {
    getUserList(1);
    handleCloseModal();
  }, [getUserList, handleCloseModal]);

  const handleRoleSelected = useCallback(
    (e) => {
      const roleSelected = e.target.value;
      setSearchByRol(roleSelected);
      if (roleSelected === "all") {
        getUserList(1);
      } else {
        getUserListByRole(1, roleSelected);
      }
    },
    [getUserList, getUserListByRole]
  );

  const handleArrowClick = useCallback(
    (userSelected, show) => {
      const theIndex = users.findIndex(
        (theUser) => theUser.id === userSelected.id
      );
      const currentUsers = [...users];
      currentUsers[theIndex].show = show;
      setUsers(currentUsers);
    },
    [users]
  );

  const handleDownload = useCallback(async () => {
    if (searchByRol === "all") {
      getUserList(1, "excel");
    } else {
      getUserListByRole(1, searchByRol, "excel");
    }
  }, [getUserList, getUserListByRole, searchByRol]);


  const navigateToProfile = useCallback(
    (theUser) => {
      const userRole = theUser?.roles?.[0]?.name?.toLowerCase();
      const userId = theUser.id;
      //dispatch(selectClient(theUser));

      if (userRole === roles.COORDINATOR) {
        return navigate(`/admin/administrative-hierarchy`);
      }

      return navigate(`/admin/user-process/${userId}`);
    },
    [dispatch, navigate]
  );

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  useEffect(() => {
    getUserById({ id: clientId }).then((response) => {
      const { data } = response?.data;
      setSelectedUserRole(data?.roles?.[0]?.name || "");

      setAdmin(data);
    });

    getOrganizationsByCoordinatorId({ createdById: clientId }).then(
      (response) => {
        const organizations = response?.data?.organizations;
        setDataHierarchy(organizations);
      }
    );
  }, [clientId]);

  useEffect(() => {
    if (first) {
      setFirst(false);
      getUserList(1);
    }
  }, [first, getUserList, user]);
  console.log({ user })
  return (
    <div className="RegisterList container mt-10">
      {loading && <Loading />}
      <div className="flex flex-col justify-center lg:flex-row lg:justify-between items-center mb-10">
        <div className="flex flex-row items-center">
          <PrimaryButton
            className="mr-5 shadow-md"
            style={{
              right: 10,
              width: 50,
              justifyItems: "center",
              borderRadius: ".2rem",
            }}
            onClick={goBack}
          >
            <FaArrowLeft size={15} />
          </PrimaryButton>
          <h1 className="title mr-4">{t("adminSections.users")}</h1>
          {user &&
            user.roles &&
            [
              "Super Admin",
              "Organizacion",
              "Administrador",
              "Vendedor",
              "Coordinador",
            ].includes(user.roles[0].name) && (
              <div className="w-full lg:w-1/6 ml-10" style={{ width: "200px" }}>
                <Selector
                  label=""
                  name="role"
                  defaultValue={() =>{

                    if (role !== roles.ADMIN) {
                      return removeRoles(role)[0]
                    }

                    return removeRoles(role).filter(
                    (r) => {
                      return r.value === roles.COORDINATOR}
                  )}}
                  options={removeRoles(role)}
                  onChange={(value) => {

                    if (value?.value !== roles.COORDINATOR) {
                      return goBack();
                    }

                    handleRoleSelected({ target: { value: value?.value } });
                  }}
                  isNewVersion
                />
              </div>
            )}
        </div>
        <PrimaryButton className="shadow max-lg:mt-10 mt-0" onClick={handleAdd}>
          {t("registerPage.add")}
        </PrimaryButton>
      </div>

      <div className="flex flex-row items-center">
        <h1 className="userTitle">{`${admin?.name || ""} ${admin?.last_name || ""
          }`}</h1>
        <span className="mx-2 text-[14px]" style={{ fontWeight: "500" }}>{selectedUserRole}</span>
      </div>
      <p className="text-[#0096B3] text-[14px]" style={{ fontWeight: "500" }}>N: <span className="text-[#0096B3]" style={{ fontWeight: "300" }}>{user?.id || ""}</span></p>
      <p className="text-[#0096B3] text-[14px] uppercase" style={{ fontWeight: "500" }} >Administrador: <span className="text-[#0096B3]" style={{ fontWeight: "300" }}>{user?.name || ""} {user?.last_name || ""}</span> </p>

      {/*dataHierarchy?.length && (
        <div className="hidden lg:block overflow-hidden rounded-lg shadow-lg mt-5">
          <table className="w-full table-fixed">
            <thead className="bg-gradient-to-r from-btnPrimaryFrom to-btnPrimaryTo text-white">
              <tr>
                <th className="p-2 w-1/3">Organización</th>
                <th className="p-2 w-1/3">Vendedor</th>
                <th className="p-2 w-1/3">Clientes</th>
              </tr>
            </thead>
            <tbody className="text-cell text-center">
              {dataHierarchy.map((organization) => (
                <React.Fragment key={organization.id}>
                  <tr
                    className="cursor-pointer"
                    onClick={() => {
                      setSelectedOrganization(
                        selectedOrganization?.id === organization.id
                          ? null
                          : organization
                      );
                      setSelectedSeller(null);
                    }}
                  >
                    <td className="p-2" style={{ verticalAlign: 'top' }}>
                      <span
                        className={`cursor-pointer block p-1 my-2 rounded 
                  ${selectedOrganization?.id === organization.id
                            ? "bg-[#5b9dd1] text-white"
                            : "bg-[#b9d3ea] text-black"
                          }`}
                      >
                        {`${organization.name} ${organization.last_name}`}
                      </span>
                    </td>
                    <td className="p-2">
                      {selectedOrganization?.id === organization.id &&
                        organization.sellers.map((seller, sellerIndex) => (
                          <div
                            key={seller.id}
                            className="mb-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedSeller(
                                selectedSeller?.id === seller.id ? null : seller
                              );
                            }}
                          >
                            <span
                              className={`cursor-pointer block p-1 text-black my-2 rounded
                        ${selectedSeller?.id === seller.id
                                  ? "bg-[#7cd092] text-white"
                                  : "bg-[#c6e9d1] text-black"
                                }`}
                            >
                              {`${seller.name} ${seller.last_name}`}
                            </span>
                          </div>
                        ))}
                    </td>
                    <td className="p-2">
                      {selectedOrganization?.id === organization.id &&
                        organization.sellers.map((seller, sellerIndex) =>
                          selectedSeller?.id === seller.id && (
                            <React.Fragment key={seller.id}>
                              {Array.from({ length: sellerIndex }).map((_, i) => (
                                <div key={i} className="py-[1.25rem]"></div>
                              ))}
                              {seller.clients.map((client) => (
                                <div
                                  key={client.id}
                                  className="mb-2"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleInfoClient(client);
                                  }}
                                >
                                  <span className="cursor-pointer block p-1 text-black my-2 rounded bg-[#bce2ed]">
                                    {`${client.name} ${client.last_name}`}
                                  </span>
                                </div>
                              ))}
                            </React.Fragment>
                          )
                        )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )*/}


      {/*dataHierarchy?.length && (
        <div className="hidden lg:block overflow-hidden rounded-lg shadow-lg mt-5">
          <table className="w-full table-fixed">
            <thead className="bg-gradient-to-r from-btnPrimaryFrom to-btnPrimaryTo text-white">
              <tr>
                <th className="p-2 w-1/3">Organización</th>
                <th className="p-2 w-1/3">Vendedor</th>
                <th className="p-2 w-1/3">Clientes</th>
              </tr>
            </thead>
            <tbody className="text-cell text-center">
              {dataHierarchy.map((organization) => (
                <React.Fragment key={organization.id}>
                  <tr
                    className="cursor-pointer"
                    onClick={() => {
                      setSelectedOrganization(
                        selectedOrganization?.id === organization.id
                          ? null
                          : organization
                      );
                      setSelectedSeller(null);
                    }}
                  >
                    <td className="p-2" style={{ verticalAlign: 'top' }}>
                      <span
                        className={`cursor-pointer block p-1 my-2 rounded 
                  ${selectedOrganization?.id === organization.id
                            ? "bg-[#5b9dd1] text-white"
                            : "bg-[#b9d3ea] text-black"
                          }`}
                      >
                        {`${organization.name} ${organization.last_name}`}
                      </span>
                    </td>
                    <td className="p-2">
                      {selectedOrganization?.id === organization.id &&
                        organization.sellers.map((seller, sellerIndex) => (
                          <div
                            key={seller.id}
                            className="mb-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedSeller(
                                selectedSeller?.id === seller.id ? null : seller
                              );
                            }}
                          >
                            <span
                              className={`cursor-pointer block p-1 text-black my-2 rounded
                        ${selectedSeller?.id === seller.id
                                  ? "bg-[#7cd092] text-white"
                                  : "bg-[#c6e9d1] text-black"
                                }`}
                            >
                              {`${seller.name} ${seller.last_name}`}
                            </span>
                          </div>
                        ))}
                    </td>
                    <td className="p-2">
                      {selectedOrganization?.id === organization.id &&
                        organization.sellers.map((seller, sellerIndex) =>
                          selectedSeller?.id === seller.id && (
                            <React.Fragment key={seller.id}>
                              {Array.from({ length: sellerIndex }).map((_, i) => (
                                <div key={i} className="py-[1.25rem]"></div>
                              ))}
                              {seller.clients.map((client) => (
                                <div
                                  key={client.id}
                                  className="mb-2"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleInfoClient(client);
                                  }}
                                >
                                  <span className="cursor-pointer block p-1 text-black my-2 rounded bg-[#bce2ed]">
                                    {`${client.name} ${client.last_name}`}
                                  </span>
                                </div>
                              ))}
                            </React.Fragment>
                          )
                        )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )*/}

      <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-lg mt-5">
        <div className="flex flex-row justify-between bg-gradient-to-r from-btnPrimaryFrom to-btnPrimaryTo text-white py-2" style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
          <div className="flex justify-center w-full"><p>Organización</p></div>
          <div className="flex justify-center w-full"><p>Vendedor</p></div>
          <div className="flex justify-center w-full"><p>Clientes</p></div>
        </div>
        <div className="flex flex-row justify-between px-4 mt-3">
          <div className="w-[100%] mr-1">
            {
              dataHierarchy?.map((organization, index) => (
                <div className="flex flex-row items-center w-[100%]">
                  <span
                    key={organization.id}
                    onClick={() => {
                      setSelectedOrganization(
                        selectedOrganization?.id === organization?.id
                          ? null
                          : organization
                      );
                      setSelectedSeller(null);
                      setClients([]);
                      setSellers({
                        length: dataHierarchy?.length,
                        index: index,
                        data: organization?.sellers
                      });
                    }}
                    className={`cursor-pointer block p-1 my-2 rounded mr-2 w-[80%] text-center
          ${selectedOrganization?.id === organization?.id
                        ? "bg-[#5b9dd1] text-white"
                        : "bg-[#b9d3ea] text-black"
                      }`}
                  >
                    {`${organization?.name} ${organization?.last_name}`}
                  </span>
                  {selectedOrganization?.id === organization?.id && <LongArrow size="40" />}
                </div>
              ))
            }
          </div>
          <div className="w-[100%]  mr-1">{
            createArrayWithData({ position: sellers?.index, size: sellers?.length + 1, data: sellers?.data })?.map((seller) => {
              if (!seller?.data?.length) {
                return (
                  <div className="mt-2 h-[14px] bg-[#ffff]"></div>
                )
              }

              return seller?.data?.map((s, index) => (
                <div className="flex flex-row items-center w-[100%]">
                  <span
                    key={s?.id}
                    onClick={() => {
                      setSelectedSeller(
                        selectedSeller?.id === s?.id ? null : s
                      );
                      setClients({
                        length: seller?.data?.length,
                        index: index,
                        data: s?.clients
                      });
                    }}
                    className={`cursor-pointer block p-1 text-black my-2 rounded mr-2 w-[80%] text-center
          ${selectedSeller?.id === s?.id
                        ? "bg-[#7cd092] text-white"
                        : "bg-[#c6e9d1] text-black"
                      }`}
                  >
                    {`${s?.name} ${s?.last_name}`}
                  </span>
                  {selectedSeller?.id === s?.id && <LongArrow size="40" />}
                </div>
              )
              )
            })

          }</div>
          <div className="w-[100%]">{

            createArrayWithData({ position: clients?.index, size: clients?.length + 1, data: clients?.data })?.map((client) => {
              if (!client?.data?.length) {
                return (
                  <div className="py-[1.5rem] bg-[#ffff]"></div>
                )
              }

              return client?.data?.map((client, index) => (
                <span
                  key={client?.id}
                  onClick={() => {
                    handleInfoClient(client);
                  }}
                  className="cursor-pointer block p-1 text-black my-2 rounded bg-[#bce2ed] text-center"
                >
                  {`${client?.name} ${client?.last_name}`}
                </span>
              ))
            })

          }</div>
        </div>

      </div>

      {showForm && (
        <Modal
          onCloseModal={handleCloseModal}
          type="medium"
          title={userToEdit ? t("registerPage.edit") : t("registerPage.add")}
          style={{
            width: "600px",
            minHeight: heightRegistrationForm(type, role),
          }}
        >
          <Register
            userToEdit={userToEdit}
            onSuccess={handleSuccess}
            setType={setType}
            type={type}
          />
        </Modal>
      )}

      {showInfoClient && (
        <Modal
          onCloseModal={handleCloseModal}
          type="medium"
          color="#fff"
          style={{
            width: "800px",
            minHeight: heightRegistrationForm(type, role),
          }}
        >
          <InfoClient client={client} />
        </Modal>
      )}

      {showTableUser && (
        <Modal onCloseModal={handleCloseModal} type="medium" title={nameUser}>
          <TableUsers
            userToEdit={userToEdit}
            onSuccess={handleSuccess}
            users={tableUsers}
          />
        </Modal>
      )}

      {toggleDetails && (
        <Modal
          onCloseModal={() => setToggleDetails(false)}
          type="medium"
          title={t("userDetails.title")}
        >
          <UserDetails user={userToShow} />
        </Modal>
      )}

      {showSale && (
        <Modal
          onCloseModal={() => {
            setShowSale(false);
          }}
          type="medium"
        >
          <SalesWizard
            toggle={showSale}
            toggleHandler={(b) => setShowSale(b)}
          />
        </Modal>
      )}

      <ToastContainer
        position="top-right"
        theme="light"
        autoClose={2000}
        style={{ width: "500px" }}
      />
    </div>
  );
}
